/**
 * Binary search an array of numbers. The `lessThan` parameter determines which index
 * is returned:
 *
 *    true  - index of element less-than-or-equal to our search
 *    false -               .. greater-than-or-equal ..
 *
 * @public
 */
export var binarySearch = function (elems, lessThan, n) {
    var lo = 0;
    var hi = elems.length - 1;
    var mid = 0;
    while (lo <= hi) {
        mid = lo + ((hi - lo) >> 1);
        var e = elems[mid];
        switch (e > n ? 1 : e < n ? -1 : 0) {
            case -1:
                lo = mid + 1;
                break;
            case 1:
                hi = mid - 1;
                break;
            default:
                // found
                return mid;
        }
    }
    // when not found, return the index of the element less than
    // or greater than the desired value
    return lessThan ? lo - 1 : lo;
};
//# sourceMappingURL=search.js.map